import Service from "lib/models/Service";

export default class LawyerService extends Service {
  async createLawyer(email: string) {
    return this.post("https://staging.lawfully-api.com/web/v1/lawyers", {
      email,
    });
  }

  async getLawyers(params: object) {
    return this.get(`/lawyers`, { size: 100, ...params });
  }

  async getLawyerIds(): Promise<string[]> {
    const data = await this.get(
      `https://prod.lawfully-api.com/web/v1/lawyers/profiles`,
    );
    return data.map((x: { lawyerId: string }) => x.lawyerId);
  }

  async getLawyerProfile(lawyerId: string): Promise<ResLawyerProfile> {
    return this.get(
      `https://prod.lawfully-api.com/web/v1/lawyers/profiles/${lawyerId}`,
    );
  }

  async getPracticeAreas() {
    return this.get("https://prod.lawfully-api.com/common/v1/speciality-types");
  }
}
